
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, UserPlus, Mail } from 'lucide-react';

interface UserTabsListProps {
  activeTab: string;
}

const UserTabsList: React.FC<UserTabsListProps> = ({ activeTab }) => {
  return (
    <TabsList className="mb-4">
      <TabsTrigger value="all" className="flex items-center">
        <Users className="mr-2 h-4 w-4" />
        <span>All Users</span>
      </TabsTrigger>
      <TabsTrigger value="admins" className="flex items-center">
        <UserPlus className="mr-2 h-4 w-4" />
        <span>Admin Users</span>
      </TabsTrigger>
      <TabsTrigger value="pending" className="flex items-center">
        <Mail className="mr-2 h-4 w-4" />
        <span>Pending Invitations</span>
      </TabsTrigger>
    </TabsList>
  );
};

export default UserTabsList;
